import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getManagerPanel } from '../../services/migration/personnelDataService';

export interface ManagerInvoicePermissions {
  canCreatePurchase: boolean;
  canUpdatePurchase: boolean;
  canDeletePurchase: boolean;
  /** Cari modülü açık mı (formda yeni cari oluşturma için). */
  canManageAccounts: boolean;
  loaded: boolean;
}

const NONE: ManagerInvoicePermissions = {
  canCreatePurchase: false,
  canUpdatePurchase: false,
  canDeletePurchase: false,
  canManageAccounts: false,
  loaded: false,
};

/**
 * Şube yöneticisinin fatura yazma yetkileri (managerPanel SettingsJson). Kural backend'deki
 * ManagerPanelPermissions.IsGranted ile aynıdır: alt yetki yalnızca Ön Muhasebe ve Faturalar
 * açıkken geçerlidir. `enabled` false ise (manager değil) istek atılmaz.
 */
export const useManagerInvoicePermissions = (enabled: boolean): ManagerInvoicePermissions => {
  const { currentUser } = useAuth();
  const [perms, setPerms] = useState<ManagerInvoicePermissions>(NONE);

  useEffect(() => {
    if (!enabled || !currentUser?.uid) {
      setPerms(NONE);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const mp = await getManagerPanel(currentUser.uid);
        const s = mp.found && mp.settings ? mp.settings : {};
        const subs = s['accountingDashboard_subPermissions'] || {};
        const invoicesOn = s['accountingDashboard'] === true && subs['accountingDashboard_invoices'] === true;
        if (cancelled) return;
        setPerms({
          canCreatePurchase: invoicesOn && subs['accountingDashboard_purchaseInvoiceCreate'] === true,
          canUpdatePurchase: invoicesOn && subs['accountingDashboard_purchaseInvoiceUpdate'] === true,
          canDeletePurchase: invoicesOn && subs['accountingDashboard_purchaseInvoiceDelete'] === true,
          canManageAccounts: s['current'] === true,
          loaded: true,
        });
      } catch (e) {
        console.warn('[useManagerInvoicePermissions] managerPanel okunamadı:', e);
        if (!cancelled) setPerms({ ...NONE, loaded: true });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, currentUser?.uid]);

  return perms;
};
